import { toast as notification, ToastContainer } from 'react-toastify';
import { friendlyMessage } from './friendlyMessage';

const DEFAULT_ERROR_TOAST_ID = 'workspace-error-notice';
const DEFAULT_ERROR_OPTIONS = {
  position: 'top-right',
  autoClose: 4000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
};

// Keep existing notification options (especially onClose navigation callbacks).
// Technical diagnostics stay in the console; the UI offers actionable guidance.
export const toast = Object.assign((...args) => notification(...args), notification, {
  error(message, options) {
    console.warn('[Workspace notice]', message);
    const displayMessage = friendlyMessage(message);
    const toastId = options?.toastId ?? DEFAULT_ERROR_TOAST_ID;
    const toastOptions = {
      ...DEFAULT_ERROR_OPTIONS,
      ...options,
      toastId,
    };

    // Several independent requests can fail together while a page is loading.
    // Keep one error notice on screen and refresh its content instead of
    // covering the interface with duplicate notifications.
    if (notification.isActive(toastId)) {
      notification.update(toastId, {
        ...toastOptions,
        render: displayMessage,
        type: 'error',
      });
      return toastId;
    }

    return notification.error(displayMessage, toastOptions);
  },
});
export { ToastContainer };
